import { loadTossScript } from '../../GiftPay/lib/toss';

// 백엔드 confirm(tossNormalPayment.service)이 일반결제 MID 시크릿 키로 승인하므로
// 결제창도 반드시 같은 MID의 일반결제 클라이언트 키로 열어야 한다 (다른 키 → 승인 거부).
const LIVE_HOSTNAMES = ['www.rappomanager.com', 'rappomanager.com'];
const isLiveHost = typeof window !== 'undefined' && LIVE_HOSTNAMES.includes(window.location.hostname);
const NORMAL_PAYMENT_CLIENT_KEY = isLiveHost
    ? process.env.REACT_APP_TOSS_NORMAL_PAYMENT_LIVE_CLIENT_KEY
    : process.env.REACT_APP_TOSS_NORMAL_PAYMENT_TEST_CLIENT_KEY;

export interface GiftCheckoutParams {
    batchId: string;
    orderId: string;
    orderName: string;
    amount: number;
    customerName?: string;
}

/** 콘솔 복귀 시 쿼리로 전달되는 결제 결과 식별 파라미터 */
export const GIFT_CHECKOUT_QUERY_KEY = 'giftCheckout';
export const GIFT_CHECKOUT_BATCH_KEY = 'checkoutBatchId';

/**
 * 관리자 콘솔 바로 결제(DIRECT_CHECKOUT) — 토스 일반결제 결제창 호출.
 * 성공/실패 시 /gifticon 으로 리다이렉트 복귀하며, 토스가 successUrl에
 * paymentKey·orderId·amount 쿼리를 덧붙인다. 페이지 마운트 시 이를 감지해 confirm을 호출한다.
 */
export const requestGiftBatchCheckout = async ({
    batchId,
    orderId,
    orderName,
    amount,
    customerName,
}: GiftCheckoutParams): Promise<void> => {
    await loadTossScript();

    if (!NORMAL_PAYMENT_CLIENT_KEY) {
        throw new Error('토스 일반결제 클라이언트 키가 설정되지 않았어요.');
    }
    if (!(window as any).TossPayments) {
        throw new Error('토스 SDK 초기화 실패');
    }

    const tossPayments = (window as any).TossPayments(NORMAL_PAYMENT_CLIENT_KEY);
    const payment = tossPayments.payment({ customerKey: 'ANONYMOUS' });

    const returnBase = `${window.location.origin}/gifticon`;
    await payment.requestPayment({
        method: 'CARD',
        amount: { currency: 'KRW', value: amount },
        orderId,
        orderName,
        successUrl: `${returnBase}?${GIFT_CHECKOUT_QUERY_KEY}=success&${GIFT_CHECKOUT_BATCH_KEY}=${batchId}`,
        failUrl: `${returnBase}?${GIFT_CHECKOUT_QUERY_KEY}=fail&${GIFT_CHECKOUT_BATCH_KEY}=${batchId}`,
        customerName,
        card: {
            useEscrow: false,
            flowMode: 'DEFAULT',
            useCardPoint: false,
            useAppCardOnly: false,
        },
    });
};
